/**
 * UI控件库 
 * @module UI
 */


;(function (ui,$) {

/**
 *  <h3>滚动控件: 上拉加载,下拉刷新</h3>
 *  <a href="../../ui_controls/bui.scroll.html" target="_blank">demo</a>
 *  <h5>公共方法</h5>
 *  {{#crossLink "bui.scroll/option"}}{{/crossLink}}: 获取设置参数 <br>
 *  {{#crossLink "bui.scroll/widget"}}{{/crossLink}}: 获取依赖控件 <br>
 *  <h5>数据交互</h5>
 *  {{#crossLink "bui.scroll/refresh"}}{{/crossLink}}: 触发下拉的方法 <br>
 *  {{#crossLink "bui.scroll/reverse"}}{{/crossLink}}: 还原位置,下拉请求完数据以后,需要还原位置 <br>
 *  {{#crossLink "bui.scroll/load"}}{{/crossLink}}: 触发加载某一页数据 <br>
 *  {{#crossLink "bui.scroll/nextPage"}}{{/crossLink}}: 触发加载下一页数据 <br>
 *  {{#crossLink "bui.scroll/prevPage"}}{{/crossLink}}: 触发加载上一页数据 <br>
 *  {{#crossLink "bui.scroll/filter"}}{{/crossLink}}: 过滤数据 <br>
 *  {{#crossLink "bui.scroll/fail"}}{{/crossLink}}: 请求失败以后,可以变为点击加载 <br>
 *  {{#crossLink "bui.scroll/updateCache"}}{{/crossLink}}: 更新分页及缓存 <br>
 *  <h5>内容交互</h5>
 *  {{#crossLink "bui.scroll/lock"}}{{/crossLink}}: 不允许滚动加载 <br>
 *  {{#crossLink "bui.scroll/unlock"}}{{/crossLink}}: 允许滚动加载 <br>
 *  {{#crossLink "bui.scroll/setHeight"}}{{/crossLink}}: 设置内容滚动高度 <br>
 *  {{#crossLink "bui.scroll/to"}}{{/crossLink}}: 滚动条跳转到第几个元素 <br>
 * 
 *  @namespace bui
 *  @class scroll
 *  @constructor 
 *  @param {object} [option] 
 *     @param option.id {string} [ 控件的ID,需要满足固定的结构 ]
 *     @param option.children {string} [ 不能为空, 找到要循环遍历的元素 例如 .bui-list li ]
 *     @param option.lastUpdated {bollean} [ 下拉的文本提醒是否显示时间 ]
 *     @param option.distance {number} [ 下拉的距离大于这个数才会触发 ]
 *     @param option.height {number} [ 为0时,自适应高度 ]
 *     @param option.page {number} [ 请求的页数,默认为1 ]
 *     @param option.pageSize {number} [ 每页的大小,默认为10 ]
 *     @param option.autoRefresh {boolean} [ 默认false 自动刷新 ]
 *     @param option.autoNext {boolean} [ 默认true 当高度不足时,会继续请求下一页,直到高度出现滚动条 ]
 *     @param option.refresh {boolean}  [ 允许下拉刷新, 默认true | false  ]
 *     @param option.autoScroll {boolean} [ 默认true 滚动到底部触发, false 自己监听 ]
 *     @param option.onRefresh {function} [ 下拉以后执行 ]
 *     @param option.onLoad {function} [ 上拉到底部执行 ]
 *     @param option.onScrolling {function} [ 滚动时触发 ]
 *     @param option.refreshTips {object} 
 *          @param option.refreshTips.start {string} [ 开始加载的文本提醒 ]
 *          @param option.refreshTips.release {string} [ 下拉的文本提醒 ]
 *          @param option.refreshTips.end {string} [ 下拉高度不足提醒 ]
 *          @param option.refreshTips.fail {string} [ 下拉加载失败提醒 ]
 *          @param option.refreshTips.success {string} [ 成功提醒 ]
 *     @param option.scrollTips {object} 
 *          @param option.scrollTips.start {string} [ 开始加载的文本提醒 ]
 *          @param option.scrollTips.end {string} [ 上拉加载的提醒 ]
 *          @param option.scrollTips.fail {string} [ 上拉加载失败提醒 ]
 *          @param option.scrollTips.nodata {string} [ 没有数据的提醒 ]
 * @example
 *
 
 html:
 *
        <div id="scroll" class="bui-scroll">
            <div class="bui-scroll-head"></div>
            <div class="bui-scroll-main">
                <ul id="scrollList" class="bui-list">
                    <li class="bui-btn">这里是循环的内容</li>
                </ul> 
            </div>
            <div class="bui-scroll-foot"></div>
        </div>

 js: 
 *   
        // 初始化
        var uiScroll = bui.scroll({
            id: "#scroll",
            children: ".bui-list .bui-btn",
            page:1,
            pageSize:10,
            onRefresh: refresh,
            onLoad: getData
        })
        
        //刷新数据
        function refresh () {

            page = 1;
            pagesize = 10;
            //请求数据
            getData(page,pagesize,"html");
        }

        //滚动加载下一页
        function getData (page,pagesize,command) {
            command = command || "append";
            
            bui.ajax({
                url: "http://localhost/mysite/yumeng/index.php/API/Usercenter/getUserList",
                data: {
                    pageindex:page,
                    pagesize:pagesize
                }
            }).done(function(res) {
                
                var data = JSON.parse(res);//有可能需要转换,视接口而定
                
                //生成html
                var html = "";
                //数据渲染

                //渲染数据
                $("#scrollList")[command](html);

                //更新分页信息
                uiScroll.updateCache(start,res.data);
                //还原位置
                uiScroll.reverse();

            }).fail(function (res) {

                // 可以点击重新加载
                uiScroll.fail(start,pagesize,res);
            })
        }
 *
 */
    ui.scroll = function (option) {

        //一个滚动加载需要用到的默认结构
        var item = "."+ui.prefix("list")+" li",
            childrenTop = "."+ui.prefix("scroll-head"),
            childrenMain = "."+ui.prefix("scroll-main"),
            childrenBottom = "."+ui.prefix("scroll-foot");

        var config = {

            id: "",
            children: item,
            childrenTop: childrenTop,
            childrenMain: childrenMain,
            childrenBottom: childrenBottom,
            distance: 100, 
            endDistance: 1, 
            height: 0,
            page: 1,
            pageSize: 10,
            lastUpdated:true,
            autoRefresh: false,
            autoNext: true,
            autoScroll: true,
            refresh: true,
            // 底下的文本提醒
            scrollTips:{
                start:"加载中...",
                end:"上拉加载更多",
                nodata: "暂无数据",
                last: "最后一页",
                fail:"点击重新加载"
            },
            // 底下的文本提醒
            refreshTips:{
                start:"刷新中...",
                release: "松开刷新",
                end:"继续下拉刷新",
                fail:"点击重新加载",
                success: "刷新成功"
            },
            onScrolling: null,
            // 上拉执行
            onRefresh: null,
            // 请求数据, 传页码及多少条数据
            onLoad: null
        }

        //方法
        var module = {
            reverse: reverse,
            updateCache: updateCache,
            getCache: getCache,
            clearCache: clearCache,
            fail: fail,
            filter: filter,
            to: to,
            lock: lock,
            unlock: unlock,
            refresh: refresh,
            load: loadData,
            nextPage: nextPage,
            prevPage: prevPage,
            setHeight: setHeight,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.scroll, option );

        var id,
            $id,
            el,
            $win,
            $children,
            $childrenBottom,
            $childrenMain,

            loadUpFn,
            loadDownFn,
            loading,            //滚动条
            uiRefresh,          //定义刷新控件
            isFail = false,     //请求失败
            isUpLock = false,     //是否刷新已经锁定
            isDownLock = false,   //是否加载已经锁定
            isLoad = false,     //是否正在加载
            isFail = false,     //是否失败
            firstFlag = true,   //是否是第一次加载
            nextFlag = true,    //加载下一页
            lastFlag = false,   //最后一页
            page = param.page,
            pageSize = param.pageSize ,
            cache = {};

        //初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            $win = $(window);

            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("scroll id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            el = $id[0];


            $children = $id.find(option.children);

            //一个scroll固有的结构
            $childrenTop = $id.children( childrenTop );
            $childrenMain = $id.children( childrenMain );
            $childrenBottom = $id.children( childrenBottom );
            
            //防止第一条数据丢失
            $childrenMain.css({
                "position":"relative"
            })
            

            //创建loading
            loading = ui.loading({
                appendTo: $childrenBottom,
                autoClose:false,
                text: option.scrollTips.start,
                display:"inline",
                mask:false
            });

            loadUpFn = loadUp;
            loadDownFn = loadFn ;

            // 先请求数据
            loadDownFn && loadDownFn.call(module,page,pageSize);

            //加载Refresh控件
            if( option.refresh && option.onRefresh ){
                //绑定刷新,但默认不加载数据
                uiRefresh = ui.pullrefresh({
                    id: option.id,
                    onRefresh: loadUpFn,
                    distance: option.distance,
                    lastUpdated: option.lastUpdated,
                    height: option.height,
                    refreshTips: option.refreshTips,
                    autoLoad: option.autoRefresh
                })
            }else{
                //初始化高度
                setHeight(option.height);
            }

            // 是否锁定上拉加载
            isDownLock = option.onLoad ? false: true;

            //滚动加载
            bind(option);


            return this;
        };


        //绑定事件
        function bind (option) {

            if( !isDownLock ){

                $id.off("scroll").on("scroll", loadMore);

            }else{
                $id.off("scroll", loadMore);

            }
        };

        //loadMore 滚动加载更多
        function loadMore (e) {
            var tar = e.target;
            var scrollTop = tar.scrollTop || 0;
           // 滚到底部了
            if ( tar.scrollTop + tar.clientHeight >= (tar&&tar.scrollHeight - param.endDistance ) && param.onLoad ) {
                //继续加载请求数据
                param.autoScroll && loadDownFn && loadDownFn.call(module,++page,pageSize);

            }

            param.onScrolling && param.onScrolling.call(this,e,module);

        }

        
        //下拉加载数据
        function loadFn(start,count) {

            isLoad = true;

            if( nextFlag && !lastFlag ){
                //是否是最后一页了
                
                loading.start({text: param.scrollTips.start,onlyText:false})

                param.onLoad && param.onLoad.call(module,start,count);

            }

            // 解锁刷新
            if( isUpLock ){
                uiRefresh && uiRefresh.unlock();
            }
            
            return this;
        };

        //上拉刷新
        function loadUp () {

            isLoad = true;

            nextFlag = true;
            lastFlag = false;
            firstFlag = false;
            page = param.page;
            pageSize = param.pageSize;

            cache = {};

            loading.start({ text: param.scrollTips.end, onlyText: true})

            param.onRefresh && param.onRefresh.call(module,page,pageSize);
            // body...
        }
        /**
         * 更新请求的分页及缓存,并继续请求下一页
         *  @method updateCache
         *  @param {string} start [当前分页]
         *  @param {object} data [当前数据]
         *  @chainable
         *  @example 
         *  
            //回调里面触发 uiScroll基于顶部例子
            uiScroll.updateCache();

         */
        function updateCache(start,data,bool) {

            //是否继续请求下一页
            var bool = bool == false ? false: true;

            //需要缓存的数据
            data = data || [];

            isLoad = false;

            //计算内容的高度
            var $children = $id.find(param.children);
            var childHeight = $children.height() * $children.length;

            var parentHeight = parseInt($id.height());
            var scrollHeight = parseInt($id.find(param.childrenMain)[0]&&$id.find(param.childrenMain)[0].scrollHeight);


            //是否继续请求数据,默认是
            if( bool ){
                // 判断是否是最后一页
                if( data && data.length > (pageSize -1) ){

                    //可以下一页
                    nextFlag = true;
                    lastFlag = false;
                    firstFlag = false;

                    loading.start({ text:param.scrollTips.end,onlyText:true });

                    //高度不足,无法出现滚动条,需要继续请求数据
                    if( scrollHeight < parentHeight && param.autoNext ){

                        loadDownFn && loadDownFn.call(module,++page,pageSize);
                    }

                }else{

                    //已经最后一页
                    nextFlag = false;
                    lastFlag = true;

                    //第一页没有数据那变提醒没有数据而不是提醒最后一页
                    var tips = firstFlag && data.length < 1 ? param.scrollTips.nodata: param.scrollTips.last;

                    loading.start({ text: tips ,onlyText:true });
                }
            }else{

                //无需继续请求
                nextFlag = false;
                lastFlag = true;
                
                loading.stop();

            }
            
            //缓存数据
            return cache[start] = data;

        };

        
        /**
         * 返回原位
         *  @method reverse
         *  @param {function} [callback] 回调
         *  @chainable
         *  @example 
         *  
            //回调里面触发 uiScroll基于顶部例子
            uiScroll.reverse();

         */
        function reverse (callback) {

            uiRefresh && uiRefresh.reverse();

            callback && callback.call(module,uiRefresh);

            return this;
        }

        //getCache 获取页面缓存
        function getCache (argument) {
            return cache;
        };
        //clearCache 清除缓存
        function clearCache (argument) {
            cache = {};

            return;
        };

        /**
         * 失败点击可以重新加载当前页
         *  @method fail
         *  @param {number} [start] 第几页
         *  @param {number} [count] 每页多少条
         *  @chainable
         *  @example 
         *  
            //回调里面触发 uiScroll基于顶部例子
            uiScroll.fail();

         */
        function fail (start,count) {

            isFail = true;
            isUpLock = true;

            loading.start({
                text: param.scrollTips.fail,
                onlyText:true,
                callback:function (argument) {
                    //点击重新加载
                    loadFn(start,count);
                }
            });

            //锁定拖拽
            uiRefresh && uiRefresh.lock();

            return this;


        }

        /**
         * 数据过滤,用于已有缓存过滤
         *  @method filter
         *  @param {string} keyword 关键字
         *  @param {string} key 在哪个字段
         *  @return {array} [返回符合条件的数据]
         *  @example 
         *  
            //过滤数据中的phone字段,是否含有139224这个数据
            var filterData = uiScroll.filter("139224","phone");

         */
        function filter (keyword,key) {
            var data = [];
            var i,j;


            if( keyword && key ){

                for( i in cache ){

                    var result = ui.filterArray(keyword,cache[i],key);

                    if( result.length ){
                        //转变为1维数组
                        for( j in result ){

                            data.push(result[j]);
                        }
                    }
                }
            }
            return data;
        }

        /**
         * 跳到指定元素
         *  @method to
         *  @param {number} index 内容的索引,例如第3个li 则 index=2
         *  @param {function} callback 跳转后执行
         *  @chainable
         *  @example 
         *  
            uiScroll.to(2);

         */
        function to (index,callback) {

            var index  = index || 0;
            $children = $id.find(param.children);
        
            var parentHeight = $id.height(),
                itemHeight = parseFloat( $children.height() );

            //计算当前总高度
            var childHeight = el.scrollHeight;

            // 得到指定的索引的滚动条高度
            var itemScrollTop =  itemHeight * parseInt(index) - itemHeight ;

            if( childHeight > parentHeight ){

                el.scrollTop = itemScrollTop;

                callback && callback.call(module,parseInt(index));
            }
            return this;

        }

        /**
         * 设置滚动的高度,常用于$(window).resize(fun)
         *  @method setHeight
         *  @param {number|string} [height] 设置的高度
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.setHeight();

         */
        function setHeight (height) {

            height = height ? parseFloat(height): $(window).height() -  ($("header").height() || 0) - ($("footer").height() || 0) - ( el&&el.offsetTop || 0 ) ;
            
            //设置高度才能滚动
            $id.height(height);

            return this;
        }

        
        /**
         * 不允许滚动加载
         *  @method lock
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.lock();

         */
        function lock (argument) {
            isDownLock = true;

            bind();

            return this;
        }

        /**
         * 允许滚动加载
         *  @method unlock
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.unlock();

         */
        function unlock (argument) {
            isDownLock = false;

            bind();
            return this;

        }  
        
        /**
         * 手动执行刷新数据
         *  @method refresh
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.refresh();

         */
        function refresh () {
            uiRefresh && uiRefresh.refresh();
            return this;

        }
        
        /**
         * 手动加载更多数据
         *  @method load
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.load();

         */
        function loadData (p) {
            var p = p || page;
                page = p;
            loadDownFn && loadDownFn.call(module,page,pageSize);
            return this;

        }
        /**
         * 加载下一页数据
         *  @method nextPage
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.nextPage();

         */
        function nextPage () {
            loadDownFn && loadDownFn.call(module,++page,pageSize);
            return this;
        }
        /**
         * 加载上一页数据
         *  @method prevPage
         *  @chainable
         *  @example 
         *  
            //uiScroll基于顶部例子
            uiScroll.prevPage();

         */
        function prevPage () {
            if( page-- > 0 ){

            loadDownFn && loadDownFn.call(module,page--,pageSize);
            }
            return this;

        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 pullrefresh loading ]
         *  @example 
            
            //获取依赖控件
            var uiScrollWidget = uiScroll.widget();
            
                
         */
        function widget(name) {
            var control = { pullrefresh: uiRefresh, loading:loading };
                return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiScroll.option();

            //获取某个参数
            var id = uiScroll.option( "id" );

            //修改一个参数
            uiScroll.option( "distance",100 );

            //修改多个参数
            uiScroll.option( {"distance":100} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }
        return module;

    };

    return ui;

})( bui || {}, libs );
